import { View, Text } from "react-native";
import { GridItem } from "ui/types/GridItem";

type Props = {
  title?: string;
  items: GridItem[];
  isNumberList?: boolean;
  sortKey?: keyof GridItem;
  sortDescending?: boolean;
};

export default function KeyValueGrid({
  title,
  items,
  isNumberList = false,
  sortKey,
  sortDescending = true,
}: Props) {
  const sortedItems = sortKey
    ? [...items].sort((a, b) => {
        const aValue = a[sortKey]
          ? new Date(a[sortKey] as string).getTime()
          : 0;
        const bValue = b[sortKey]
          ? new Date(b[sortKey] as string).getTime()
          : 0;
        return sortDescending ? bValue - aValue : aValue - bValue;
      })
    : items;

  return (
    <View>
      {title ? (
        <Text className="text-typography-900 capitalize font-semibold text-sm mb-6">
          {title}
        </Text>
      ) : null}
      <View className="gap-y-6">
        {sortedItems.map((item, index) => {
          const isFullRow = !!item.description || !item.label;

          return (
            <View key={index} className="flex-row gap-4">
              {isFullRow ? (
                <Text className="text-typography-500 capitalize">
                  {item.value}
                </Text>
              ) : (
                <>
                  <View
                    className={`flex flex-row items-start w-[200px] max-w-[40%] gap-2`}
                  >
                    {isNumberList ? (
                      <Text className="text-typography-500">{index + 1}.</Text>
                    ) : null}
                    <Text className="text-typography-500 capitalize">
                      {item.label}
                    </Text>
                  </View>
                  <View className="flex-1">
                    <Text className="text-typography-900 capitalize">
                      {item.value}
                    </Text>
                  </View>
                </>
              )}
            </View>
          );
        })}
      </View>
    </View>
  );
}
